import gsap, { Power3, Power4 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { isDebug } from '../_app/cuchillo/core/Basics';


export default class Logo {
  static container = GetBy.id('Logo');
  static items = [];
  static total = 0;

  static get height() { return this.size.height; }
  static set height(__height) {
    this.size.height = __height;
    document.body.style.setProperty('--index-height', `${this.size.height}px`);
  }

  static init () {
    this.setupChars();
    this.setupAnimation();
  }

  static setupChars() {
    const chars = [...GetBy.selector("[data-char]")].map(char => {
      const item = {
        dom:char,
        char:char.dataset.char,
        width:0,
        height:0
      }

      this.items.push(item);
    });
    this.total = this.items.length;
    this.updateSizes();
  }

  static setupAnimation() {
    for(let i=0; i<this.total; i++) {
      this.items[i].dom.style.display = "none";
    }


    let time = 0.2;
    this.tlLeft = gsap.timeline({ paused: true });
    this.tlLeft
      .set('[data-char-id="5"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="4"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="3"]', { display: 'block' })
      .set('[data-char-id="5"]', { display: 'none' })
      .set('[data-char-id="8"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="2"]', { display: 'block' })
      .set('[data-char-id="4"]', { display: 'none' })
      .set('[data-char-id="7"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="1"]', { display: 'block' })
      .set('[data-char-id="3"]', { display: 'none' })
      .set('[data-char-id="6"]', { display: 'block' })
      .set('[data-char-id="8"]', { display: 'none' })
      .set('[data-char-id="9"]', { display: 'block' });

    // Timeline para la parte derecha
    this.tlRight = gsap.timeline({ paused: true });
    this.tlRight
      .set('[data-char-id="14"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="13"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="12"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="11"]', { display: 'block' })
      .set('[data-char-id="14"]', { display: 'none' })
      .set('[data-char-id="18"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="10"]', { display: 'block' })
      .set('[data-char-id="13"]', { display: 'none' })
      .set('[data-char-id="17"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="12"]', { display: 'none' })
      .set('[data-char-id="16"]', { display: 'block' })
      .to({}, { duration: time })
      .set('[data-char-id="11"]', { display: 'none' })
      .set('[data-char-id="15"]', { display: 'block' })
      .set('[data-char-id="14"]', { display: 'none' })
      .set('[data-char-id="18"]', { display: 'none' })
      .set('[data-char-id="19"]', { display: 'block' });
}

  static updateSizes() {
    for(let i=0; i<this.total; i++) {
      const item = this.items[i];
      const domRect = item.dom.getBoundingClientRect();
      this.items[i].width = domRect.width;
      this.items[i].height = domRect.height;
      
      //if(item.char == "p" || item.char == "z" || item.char == "v") document.body.style.setProperty(`--char-size-${item.char}`, `${domRect.width}px`);
    }
  }

  static show(__call) {
    this.tlRight.restart();

    setTimeout(()=> {
      this.tlLeft.restart();
    }, 400);

    if(isDebug) {
      __call();
    } else {
      setTimeout(()=> {
        __call();
      }, 1200);
    }
  }

  // HIDE
  static hide(__d = 0) {
  }

  static loop() {
    if(!this.items[0]) return;
  }
  
  static resize() {
    this.updateSizes();
  }
}
